import React from 'react';
import banner from '../../assets/startups/connectvast-banner.jpg';
import variables from '../../styles/variables.module.scss';
import Highlight from '../../components/Highlight';
import c2cLogo from '../../assets/logos/connect2capital-logo.png';

export default {
  logo: { fall: c2cLogo },
  banner: { fall: banner },
  title1: 'Are you an ambitious and driven entrepreneur?',
  desc1: (
    <span>
      Do you have an idea to build something new and
      awesome? Something that can shake up the status quo?
      Something that can create significant business,
      societal or environmental value?
    </span>
  ),
  title2: "Then you're in the right place!",
  desc2: (
    <span>
      We App is a full-stack service company within software
      development and design. We house a talented team of
      designers, developers and business professionals.
    </span>
  ),
  title3: 'And we love entrepreneurs!',
  desc3: (
    <span>
      There are so many great ideas out there. And we know
      that what teams often lack is access to software
      developers. So we want to help you develop your dream!
      Apply now.
    </span>
  ),
  title4: 'Attendance possibilities and important dates',
  desc4: (
    <span>
      <p>
        This competition consists of two events and some
        important deadlines. We, therefore, need to make
        sure that you and your team will be able to attend
        and keep all important sets of dates.
      </p>
      <ul>
        <li style={{ marginBottom: 8 }}>
          <p>
            <b>16th of October</b>
            {` - Submission deadline for
            pitch. The finalists will be announced shortly after the deadline.`}
          </p>
        </li>
        <li style={{ marginBottom: 8 }}>
          <p>
            <b>1st of November</b>
            {` - Pitch practice &
            meet and greet with We App.`}
          </p>
        </li>
        <li style={{ marginBottom: 8 }}>
          <p>
            <b>15th of November</b>
            {` - Stage pitching at Connect2Capital event in Gothenburg.`}
          </p>
        </li>
      </ul>
    </span>
  ),
  title5: 'About the idea & your team',
  desc5:
    'We would love to get to know a little bit more about your idea.',
  title6: 'The business',
  desc6:
    ' Tell us a little about where you are currently at.',
  title7: 'Tip',
  desc7: (
    <ul>
      <li style={{ marginBottom: 8 }}>
        <p>
          The simpler you can explain any of the below
          points, the better.
        </p>
      </li>
    </ul>
  ),
  footerText: (
    <span>
      {`We're really excited to hear about your idea! In case
    of any questions, please contact `}
      <a
        href="mailto:hello@weapp.se"
        style={{ color: variables.springGreen }}
      >
        hello@weapp.se
      </a>
    </span>
  ),
  title8: 'In partnership with Connect2Capital',
  desc8: (
    <span>
      {`The competition has been made possible by partnering
      with Connect2Capital. An event where startups, venture
      capital and other startup actors meet and connect.
      Together we give startups the chance to pitch on stage
      at Connect2Capital for the grand prize of `}
      <Highlight>
        <b>100 hours of software expertise with We App</b>
      </Highlight>
      .
    </span>
  ),
  placeholderAboutTeam:
    'Your team is really important. Tell us about your team members and the relevant experiences, backgrounds and skills in the team. *',
  placeholderFirstMilestone:
    "What is the company's first milestone? What obstacles must be overcome to get there? *",
  placeholderScalabilityAndMarketPotential:
    'Scalability. How will your business scale? What is the future potential?  *',
  placeholderCompetitors:
    'Competitors. Are there similar ideas existing in the market? If so, give examples and explain how your idea differs from these? *',
  placeholderBusinessModel:
    'Business model. How will the idea make money? When will revenue start being generated? *',
  labelMixedGender: 'Do you have a mixed gender team?',
  placeholderEvidenceOfDemand:
    'What evidence do you have that this is a problem that needs to be solved? Why are users not fully satisfied with existing solutions? *',
  placeholderTargetCustomerAndProblem:
    'Who is the idea for? What problem will the product / service solve for them? *',
  placeholderIdeaDesc:
    'Describe your idea shortly (3-5 sentences) *',
  placeholderSellTheIdea:
    'Sell the idea! The floor is yours',
  labelTeamName: 'Name of your team/idea',
  labelCity: 'City the team is based in',
  labelMobile: 'Mobile (for sms)',
  labelWebsite: 'Website (if you have one)',
  labelEmail: 'Email',
  labelName: 'First and last name',
};
